import React from 'react';
import withHeader from "../../hocs/withHeader";
import SurveyEditor from "./builder/SurveyEditor";
import SurveyPageMenu from "./SurveyPageMenu";
import {Redirect, Route, Switch, useLocation} from "react-router-dom";
import SurveyReportsPage from "./reports/SurveyReportPage";
import SurveyPageFooter from "./SurveyPageFooter";
import SurveySharePage from "./share/SurveySharePage";
import SurveyPreviewPage from './preview/SurveyPreviewPage';

function SurveyPage(props) {
    var {match} = props;
    const location = useLocation();
    const toRedirectEditor = {pathname: `${match.path}/builder`, state: location.state};

    return (
        <section className="questionaire">
            <SurveyPageMenu/>

            <Switch>
                <Route exact path={`${match.path}/builder`} render={(parentProps) => (<SurveyEditor {...parentProps}/>)}/>
                <Route exact path={`${match.path}/builder/:surveyId`} render={(parentProps) => (<SurveyEditor {...parentProps}/>)}/>
                <Route exact path={`${match.path}/preview/:surveyId`} render={(parentProps) => (<SurveyPreviewPage {...parentProps}/>)}/>
                <Route exact path={`${match.path}/share/:surveyId`} render={(parentProps) => (<SurveySharePage {...parentProps}/>)}/>
                <Route exact path={`${match.path}/reports/:surveyId`} render={(parentProps) => (<SurveyReportsPage {...parentProps}/>)}/>
                <Redirect from={`${match.path}/`} to={toRedirectEditor}/>
            </Switch>

            <SurveyPageFooter/>
        </section>
    )
}

export default withHeader(SurveyPage);